/**
 * Формирует URL с параметрами для навигации в SPA.
 * @param baseUrl Базовый URL (относительный путь, например, "/ws-inv-acts")
 * @param searchParams Объект с параметрами (например, { openFlt: "1" }). Опционален.
 * @returns Строка с относительным путём и параметрами
 */
export const buildUrl = (
    baseUrl: string,
    searchParams: Record<string, string | number | boolean | undefined> = {},
): string => {
    const params = new URLSearchParams();

    Object.entries(searchParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            params.append(key, String(value));
        }
    });

    return params.toString().length > 0 ? `${baseUrl}?${params.toString()}` : baseUrl;
};
